export { h as default } from './chunks/index-DcEF47R4.mjs';
import '@strapi/design-system';
import 'react/jsx-runtime';
import '@strapi/content-manager/strapi-admin';
import 'react-router-dom';
import 'react';
import '@strapi/admin/strapi-admin';
import 'react-intl';
import 'react-redux';
import '@strapi/admin/strapi-admin/ee';
import '@strapi/icons';
import 'styled-components';
//# sourceMappingURL=index.mjs.map
